import { env } from "@/env";

export const padLeft = (value: number, length = 2): string =>
  value.toString().padStart(length, "0");

export const formatTimestamp = ({
  timestamp,
  format = "srt",
}: {
  timestamp: number;
  format?: string;
}) => {
  const date = new Date(0, 0, 0, 0, 0, 0, timestamp);

  const hours = date.getHours();
  const minutes = date.getMinutes();
  const seconds = date.getSeconds();
  const ms = Math.floor(timestamp - (hours * 3600000 + minutes * 60000 + seconds * 1000));

  return `${padLeft(hours)}:${padLeft(minutes)}:${padLeft(seconds)}${
    format === "vtt" ? "." : ","
  }${padLeft(ms, 3)}`;
};

type OptionalSubsDownloadLinkParams = {
  format?: "srt" | "vtt" | "txt";
  lines?: boolean;
  base64?: boolean;
  speakers?: boolean;
  lastNed?: boolean;
  styleString?: string;
};

export const getSubsDownloadLink = ({
  format,
  lines,
  base64 = false,
  speakers = false,
  lastNed = false,
  styleString,
  ...rest
}: OptionalSubsDownloadLinkParams & ({ jobId: string } | { runId: string })) => {
  const baseUrl =
    typeof window !== "undefined" ? window.location.origin : env.NEXT_PUBLIC_FRONTEND_URL;
  const url = new URL("/api/v1/get-srt", baseUrl);
  if ("jobId" in rest) {
    url.searchParams.append("id", rest.jobId);
  }
  if ("runId" in rest) {
    url.searchParams.append("runId", rest.runId);
  }
  if (format) {
    url.searchParams.append("format", format);
  }
  if (lines) {
    url.searchParams.append("lines", "true");
  }
  if (base64) {
    url.searchParams.append("base64", "true");
  }
  if (speakers) {
    url.searchParams.append("speakers", "true");
  }
  if (lastNed) {
    url.searchParams.append("lastNed", "true");
  }
  if (styleString) {
    url.searchParams.append("styleString", styleString);
  }
  return url.toString();
};
